const domainfromrequest = window.location.hostname;
export const API_URL = "https://qsrasset.iar.net.in/"+domainfromrequest+"-productlist.json"
export const STORE_DETAILS = "https://qsrasset.iar.net.in/"+domainfromrequest+"-storedetail.json"
export const API_URL_ADD = "https://shopzen.stutzen.in/index.php?route=rest/reactiar/checkoutsubmit"
export const API_CHECKOUT_SAVE = "https://"+domainfromrequest+"/iar/sendMailSms"
export const API_STORE_DETAIL ="https://shopzen.stutzen.in/index.php?route=rest/reactiar/storeInfo"
export const API_PRODUCT_LIST ="https://shopzen.stutzen.in/index.php?route=rest/reactiar/listProducts"
export const API_CATEGORY_LIST = "https://shopzen.stutzen.in/index.php?route=rest/reactiar/listCategories"
export const API_PRODUCT_AND_STORE = "https://v2files.iar.net.in/files/"+domainfromrequest+"/"+domainfromrequest+"-config.json?"+Math.random()
